import { ArrowUpOnSquareIcon } from "@heroicons/react/24/solid";
import { ChangeEventHandler } from "react";
import { Button, Icon, IconSpinner, Text } from "../../../components";

const uploadButtonStyles = `
    flex
    border-2
    border-dashed
    border-table-x
    rounded
    w-full
    h-48
    items-center
    justify-center
`;

interface ButtonUploadImageProps {
  /** The text of the Descriptor at the top-left of the image upload button. */
  descriptorText: string;
  /** The text for the Button at the top-right of the image upload button, only visible if `preview` is set. */
  uploadButtonText: string;
  /** The text for the image placeholder, only visible if `preview` is not set. */
  uploadText: string;
  id: string;
  /** A preview image, encoded as data-URL. */
  preview?: string;
  isLoading?: boolean;
  onChange?: ChangeEventHandler<HTMLInputElement>;
}

export const ButtonUploadImage = (props: ButtonUploadImageProps) => {
  const {
    id,
    descriptorText,
    uploadButtonText,
    uploadText,
    preview,
    isLoading,
    onChange
  } = props;
  return (
    <label htmlFor={id} className="mb-8 mt-3 w-full cursor-pointer">
      <div className="flex items-center justify-between">
        <Text
          classNameText="py-1 px-4
  text-sm
  font-semibold
  uppercase
  font-primary
  text-black-lighter"
          text={descriptorText}
        />
        {preview && (
          <Button icon={ArrowUpOnSquareIcon} text={uploadButtonText} />
        )}
      </div>
      <div className={preview ? "" : uploadButtonStyles}>
        {isLoading ? (
          <div className={`${uploadButtonStyles}`}>
            <IconSpinner className="text-primary" />
          </div>
        ) : preview ? (
          <div className="overflow-hidden rounded shadow">
            <img src={preview} alt={id} className="w-full" />
          </div>
        ) : (
          <div className="flex flex-col">
            <Icon
              Icon={ArrowUpOnSquareIcon}
              classNameIcon="black-lightest mx-auto mb-2 w-8 h-8"
            />
            <Text text={uploadText} />
          </div>
        )}
      </div>
      <input
        id={id}
        name="image"
        type="file"
        accept="image/png, image/jpeg"
        className="sr-only"
        onChange={onChange}
      />
    </label>
  );
};
